import { ReactNode, useState } from "react"

import { useBookingContext } from "modules/Booking/BookingContext"
import { PaymentSystemType } from "utils/interfaces"
import { CurrencySelectorPayment } from "modules/BookingCommon/components"
import { NewBookingPageLink } from "app/AppRouter/links"
import { useCurrency, useOnSuccessFullPayment } from "modules/Booking/common/hooks"
import { AfterPaymentPage } from "modules/Booking/AfterPaymentPage"
import { Img } from "ui-kit/components-branded/index"
import { PaymentWidget } from "components"
import { createdBookingLoader } from "modules/BookingCommon/common/queries"
import { isBookingAvailable } from "utils/bookingAvailable"

export function ErrorPage({
    headline,
    secondary,
    tryAgain,
    buttonText = "Выбрать другое время",
}: {
    headline: string
    secondary: ReactNode
    tryAgain?: boolean
    buttonText?: string
}) {
    const [{ sessionType }] = useBookingContext()
    const bookingHash = createdBookingLoader.getHash()
    const { data: bookingDetails } = createdBookingLoader.useGet(bookingHash)
    const psy = bookingDetails?.psy
    const [rerenderWidget, setRerenderWidget] = useState(false)
    const [paymentSystem, setPaymentSystem] = useState<PaymentSystemType | undefined>(
        bookingDetails?.payment_system
    )
    const [showAfterPayment, setShowAfterPayment] = useState(false)
    const onSuccessfulPayment = useOnSuccessFullPayment(() => setShowAfterPayment(true))
    const { currency, setCurrency, updateCurrency } = useCurrency()

    const handleClick = async () => {
        if (!bookingDetails) return
        const response = await updateCurrency()
        if (response && response.payment_system) {
            setPaymentSystem(response.payment_system)
            setRerenderWidget(true)
        }
    }

    if (showAfterPayment) {
        return <AfterPaymentPage />
    }

    return (
        <div className="redesign-container">
            <div className="try-again__container">
                <section className="try-again">
                    <div>
                        <div className="try-again__headline">{headline}</div>
                        <div className="try-again__text">{secondary}</div>
                    </div>
                    <Img
                        className="try-again__card-illustration"
                        src="error-illustration.svg"
                        width={296}
                        height={168}
                    />

                    {tryAgain ? (
                        <>
                            <CurrencySelectorPayment
                                currency={currency}
                                updateCurrency={setCurrency}
                            />
                            <a
                                onClick={() => void handleClick()}
                                className="try-again__primary-button b-button transition-ease"
                            >
                                Перейти к&nbsp;оплате еще раз
                            </a>
                            {rerenderWidget && bookingDetails && (
                                <PaymentWidget
                                    {...bookingDetails}
                                    payment_system={paymentSystem}
                                    onSuccess={onSuccessfulPayment}
                                    onError={() => setShowAfterPayment(false)}
                                    sessionType={sessionType}
                                    psy={PaymentWidget.getPsyData(bookingDetails.psy)}
                                />
                            )}
                        </>
                    ) : (
                        psy &&
                        isBookingAvailable(psy) && (
                            <NewBookingPageLink
                                hashId={psy.hash_id}
                                target="_blank"
                                className="border-radius-5 py-3 px-5 text-center b-button button--regular w-100 try-again__secondary-button transition-ease"
                            >
                                {buttonText}
                            </NewBookingPageLink>
                        )
                    )}
                </section>
            </div>
        </div>
    )
}
